const templateBenefit = {
    init() {
        const faqItems = document.querySelectorAll('.benefit-faq__item');
        if (!faqItems.length) return;

        faqItems.forEach((item) => {
            const question = item.querySelector('.benefit-faq__question');
            if (!question) return;

            question.addEventListener('click', () => {
                faqItems.forEach((otherItem) => {
                    if (otherItem !== item) {
                        otherItem.classList.remove('active');
                    }
                });
                item.classList.toggle('active');
            });
        });
    }
};

export default templateBenefit;

